import { createSlice } from '@reduxjs/toolkit';
const initialState = { keywords: '' };
const gapReportModal = createSlice({
  name: 'gapReportModal',
  initialState,
  reducers: {
    showgapReportModal: (state, action) => {
      return action.payload;
    },
    hidegapReportModal: state => {
      return initialState;
    }
  }
});
export const { showgapReportModal, hidegapReportModal } = gapReportModal.actions;
export default gapReportModal;
